import React, { useEffect } from "react";
import styled from "styled-components";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const ContentWrapper = styled.main`
  flex: 1;
  max-width: 900px;
  margin: 0 auto;
  padding: 120px 20px 60px;

  @media (max-width: 768px) {
    padding: 100px 16px 40px;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #02495b;
  margin-bottom: 30px;
  font-family: 'Merriweather', serif;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Section = styled.section`
  margin-bottom: 30px;
`;

const SectionTitle = styled.h2`
  font-size: 1.4rem;
  color: #035e75;
  margin-bottom: 15px;
  font-family: 'Merriweather', serif;
`;

const Paragraph = styled.p`
  font-size: 1rem;
  color: #444;
  line-height: 1.8;
  margin-bottom: 15px;
`;

const List = styled.ul`
  padding-left: 25px;
  margin-bottom: 15px;
`;

const ListItem = styled.li`
  font-size: 1rem;
  color: #444;
  line-height: 1.8;
  margin-bottom: 8px;
`;

const LastUpdated = styled.p`
  font-size: 0.9rem;
  color: #888;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #eee;
`;

const PaymentPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <Navbar />
      <ContentWrapper>
        <Title>Payment Policy</Title>

        <Section>
          <SectionTitle>Accepted Payment Methods</SectionTitle>
          <Paragraph>Trippro accepts the following payment methods for booking travel packages:</Paragraph>
          <List>
            <ListItem>UPI (Google Pay, PhonePe, Paytm, etc.)</ListItem>
            <ListItem>Net Banking</ListItem>
            <ListItem>Credit / Debit Cards (Visa, MasterCard, RuPay)</ListItem>
            <ListItem>Bank Transfer / NEFT / RTGS</ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>Booking Confirmation</SectionTitle>
          <Paragraph>
            A minimum advance payment of 30-50% of the total package cost is required to confirm your booking.
            The exact amount may vary based on the destination, travel dates, and package type.
            Our travel advisor will provide specific payment requirements at the time of booking.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>Balance Payment</SectionTitle>
          <Paragraph>
            The remaining balance must be paid at least 7 days before the travel start date.
            For last-minute bookings (within 7 days of travel), full payment is required at the time of booking.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>Payment Security</SectionTitle>
          <Paragraph>
            All payments are processed through secure payment gateways. Trippro does not store your
            credit/debit card details. Your financial information is encrypted and handled with industry-standard security measures.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>Invoice & Receipt</SectionTitle>
          <Paragraph>
            Upon successful payment, you will receive a confirmation email along with a detailed
            invoice/receipt. Please retain this for your records.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>Contact for Payment Queries</SectionTitle>
          <Paragraph>
            For any payment-related queries, please contact us:
          </Paragraph>
          <List>
            <ListItem>📞 Phone: +91 92113 76008</ListItem>
            <ListItem>📧 Email: contact@trippro.in</ListItem>
            <ListItem>💬 WhatsApp: +91 92113 76008</ListItem>
          </List>
        </Section>

        <LastUpdated>Last updated: February 2026</LastUpdated>
      </ContentWrapper>
      <Footer />
    </PageContainer>
  );
};

export default PaymentPolicy;
